interface QuestionnaireHeaderProps {
  logoUrl: string;
  currentQuestion: number;
  totalQuestions: number;
  isDetailsStep?: boolean;
}

export function QuestionnaireHeader({
  logoUrl,
  currentQuestion,
  totalQuestions,
  isDetailsStep = false,
}: QuestionnaireHeaderProps) {
  const completed = isDetailsStep ? totalQuestions : currentQuestion;
  const progress = Math.round((completed / totalQuestions) * 100);

  return (
    <header className="questionnaire-header">
      <div className="questionnaire-header__top">
        <a
          className="questionnaire-logo"
          href="/"
          aria-label="Evolution by Corina, volver al inicio"
        >
          <img src={logoUrl} alt="Evolution by Corina" />
        </a>
        <a className="questionnaire-exit" href="/">
          <span aria-hidden="true">×</span>
          <span className="questionnaire-exit__label">Salir</span>
        </a>
      </div>

      <div className="questionnaire-progress">
        <div className="questionnaire-progress__meta">
          <span>
            {isDetailsStep
              ? "Último paso"
              : `Pregunta ${String(currentQuestion).padStart(2, "0")} de ${String(
                  totalQuestions,
                ).padStart(2, "0")}`}
          </span>
          <span aria-hidden="true">{progress}%</span>
        </div>
        <div
          className="questionnaire-progress__track"
          role="progressbar"
          aria-label="Progreso del cuestionario"
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={progress}
          aria-valuetext={
            isDetailsStep
              ? "Preguntas completadas, último paso"
              : `Pregunta ${currentQuestion} de ${totalQuestions}`
          }
        >
          <span style={{ width: `${progress}%` }} />
        </div>
      </div>
    </header>
  );
}

